import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import helperColumns from '../../../DataComponent/helper';

const financeOperations = (state) => state.financeOperations.list;
const serverStore = (state) => state.serverStorage.store;
const currency = (state) => state.routingCompat?.query?.currency;

export const mainSelector = createSelector(
    financeOperations,
    currency,
    (financeOperations = [], currency) => {
        const t = UserStore.getTranslation() || {};
        const staticNameLabels = (t.dataTable && t.dataTable.headers) || {};

        let list = [];

        financeOperations.forEach((item) => {
                list.push({
                    AdvertiserName: (
                        <div>
                            <span className="wrap__desktop">{item.AdvertiserName}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.AdvertiserName}</div>
                                <div className="row-value">{item.AdvertiserName}</div>
                            </div>
                        </div>
                    ),
                    AdvertiserSite: (
                        <div>
                            <span className="wrap__desktop">{item.AdvertiserSite}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.AdvertiserSite}</div>
                                <div className="row-value">{item.AdvertiserSite}</div>
                            </div>
                        </div>
                    ),
                    Period: (
                        <div>
                            <span className="wrap__desktop">{item.Period}</span>
                            <div className="wrap__mobile">
                                <div className="row-value header">{item.Period}</div>
                            </div>
                        </div>
                    ),
                    PublisherId: (
                        <div>
                            <span className="wrap__desktop">{item.PublisherId}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.PublisherId}</div>
                                <div className="row-value">{item.PublisherId}</div>
                            </div>
                        </div>
                    ),
                    PublisherName: (
                        <div>
                            <span className="wrap__desktop">{item.PublisherName}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.PublisherName}</div>
                                <div className="row-value">{item.PublisherName}</div>
                            </div>
                        </div>
                    ),
                    FTDsCount: (
                        <div>
                            <span className="wrap__desktop">{item.FTDsCount.toString()}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.FTDsCount}</div>
                                <div className="row-value">{item.FTDsCount.toString()}</div>
                            </div>
                        </div>
                    ),
                    CommissionRS: (
                        <div>
                            <span className="wrap__desktop">{I18nFormatter.currency(item.CommissionRS, currency, true)}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.CommissionRS}</div>
                                <div className="row-value">{I18nFormatter.currency(item.CommissionRS, currency, true)}</div>
                            </div>
                        </div>
                    ),
                    CommissionCPA: (
                        <div>
                            <span className="wrap__desktop">{I18nFormatter.currency(item.CommissionCPA, currency, true)}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.CommissionCPA}</div>
                                <div className="row-value">{I18nFormatter.currency(item.CommissionCPA, currency, true)}</div>
                            </div>
                        </div>
                    ),
                    CommissionTotal: (
                        <div>
                            <span className="wrap__desktop">{I18nFormatter.currency(item.CommissionTotal, currency, true)}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.CommissionTotal}</div>
                                <div className="row-value">{I18nFormatter.currency(item.CommissionTotal, currency, true)}</div>
                            </div>
                        </div>
                    ),
                    PaidTotal:(
                        <div>
                            <span className="wrap__desktop">{I18nFormatter.currency(item.PaidTotal, currency, true)}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.PaidTotal}</div>
                                <div className="row-value">{I18nFormatter.currency(item.PaidTotal, currency, true)}</div>
                            </div>
                        </div>
                    ),
                    BalanceEndDebt: (
                        <div>
                            <span className="wrap__desktop">{I18nFormatter.currency(item.BalanceEndDebt, currency, true)}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.BalanceEndDebt}</div>
                                <div className="row-value">{I18nFormatter.currency(item.BalanceEndDebt, currency, true)}</div>
                            </div>
                        </div>
                    ),
                    BalanceEndHold: (
                        <div>
                            <span className="wrap__desktop">{I18nFormatter.currency(item.BalanceEndHold, currency, true)}</span>
                            <div className="wrap__mobile">
                                <div className="row-title">{staticNameLabels.BalanceEndHold}</div>
                                <div className="row-value">{I18nFormatter.currency(item.BalanceEndHold, currency, true)}</div>
                            </div>
                        </div>
                    )
                });
        });
        
        return list;
    }
);

export const getHeaderName = createSelector(
    serverStore,
    () => {
        return helperColumns.getDate('financeOperations');
    }
);
